import { createContext, useContext } from 'react';

import { Company } from '../types/company';
import { FooterGroup } from '../types/footer';
import { MenuItem } from '../types/menu';

export type ConfigState = {
  company: Company;
  footer: FooterGroup[];
  menu: MenuItem[];
};

const EMPTY_COMPANY: Company = {
  contact: { img: { alt: '', src: '' }, text: '' },
  email: '',
  isHQ: false,
  name: '',
  phone: '',
  phoneText: '',
  schedule: [],
  trialFee: 0,
};

const EMPTY_CONFIG = { company: EMPTY_COMPANY, footer: [], menu: [] };

export const ConfigContext = createContext<ConfigState | undefined>(undefined);

export const useConfigContext = (): ConfigState => {
  const value = useContext<ConfigState | undefined>(ConfigContext);
  return value || EMPTY_CONFIG;
};
